import React from 'react';
import { connect } from 'react-redux';

import { UserAccountId } from 'api/UserAccount/model/UserAccountId';

import { Button } from 'shared/components/Button';
import { LoadingCover } from 'shared/components/LoadingCover';
import { SignUpFormActions, SignUpFormDispatch } from 'shared/components/SignUpOrSignIn/SignUpForm/actions';
import { ISignUpOptionsState } from 'shared/components/SignUpOrSignIn/SignUpOptions/reducers';
import { ValidationInput } from 'shared/components/ValidationInput';

import { GetStartedFormActions } from 'apps/PublicSite/GetStartedForm/actions';

import { SignUpAndLoginDispatch } from '../SignUpAndLoginButtons/actions';
import { ISignUpAndLoginButtonsState } from '../SignUpAndLoginButtons/reducers';

import { PathUtils } from 'shared/utils/pathUtils';

import './GetStartedWithEmail.scss';

interface IGetStartedWithEmailProps {
    signUpAndLoginButtonsState : ISignUpAndLoginButtonsState;
    signUpOptionsState : ISignUpOptionsState;
}

interface IConnectedGetStartedWithEmailProps extends IGetStartedWithEmailProps {
    dispatch : SignUpAndLoginDispatch & SignUpFormDispatch;
}

interface IGetStartedWithEmailState {
    email : string;
}

export class GetStartedWithEmail extends React.Component<IConnectedGetStartedWithEmailProps, IGetStartedWithEmailState> {
    constructor(props : IConnectedGetStartedWithEmailProps) {
        super(props);
    }

    public render() {
        const {
            signUpAndLoginButtonsState,
            signUpOptionsState,
        } = this.props;

        if (typeof signUpAndLoginButtonsState.loggedInUser  === 'undefined') {
            return (
                <LoadingCover
                    className="overlay-light inline"
                    hasLoadingIcon={ true }
                />
            );
        }
        if (signUpAndLoginButtonsState.loggedInUser) {
            return null;
        }

        const emailAddress = signUpOptionsState.signUpOptionsForm.signUpForm.validationInputDataByFieldName.emailAddress;
        return (
                <div className="get-started-with-email">
                    <div className="inner-container">
                        <div className="email-entry-container">
                            <ValidationInput
                                inputClassName="email-entry"
                                type="email"
                                autoFocus={ false }
                                autoComplete={ null }
                                errorMessage={ emailAddress.errorMessage }
                                isValid={ emailAddress.isValid }
                                handleBlur={ this.onFormFieldChange }
                                handleFocus={ null }
                                handleChange={ this.onFormFieldChange }
                                handleEnterClick={ this.doNothing }
                                label=""
                                hintText="Email address"
                                value={ emailAddress.value }
                                isDisabled={ false }
                            />
                            <Button
                                buttonClassName="ml-xs emphasis"
                                isDisabled={ false }
                                isLoading={ false }
                                onClick={ this.onSignUpAndCreateRetailerFormSubmit }
                            >
                                Get Started
                            </Button>
                        </div>
                        <p>
                            Already have an account?
                            <Button
                                buttonClassName="primary medium flat normal"
                                isDisabled={ false }
                                isLoading={ false }
                                onClick={ this.onSignIn }
                            >
                                Sign in
                            </Button>
                        </p>
                    </div>
                </div>
        );
    }

    private readonly doNothing = () => {
        // pass
    }

    private readonly onSignIn = () => {
        window.location.href = PathUtils.getAbsolutePathForRequest('/login');
    }

    private readonly onFormFieldChange = (e : React.ChangeEvent<HTMLInputElement>) => {
        const emailValue = e.target.value;
        this.props.dispatch(SignUpFormActions.onFormFieldChange('emailAddress', emailValue));
        this.props.dispatch(SignUpFormActions.onFormFieldChange('firstName', emailValue));
        this.props.dispatch(SignUpFormActions.onFormFieldChange('lastName', 'Bevspot'));
    }

    private readonly onSignUpAndCreateRetailerFormSubmit = () => {
        const {
            dispatch,
            signUpOptionsState,
        } = this.props;

        const validationInputDataByFieldName = signUpOptionsState.signUpOptionsForm.signUpForm.validationInputDataByFieldName;
        dispatch(SignUpFormActions.onSubmit(signUpOptionsState.signUpOptionsForm.signUpForm, false, false, true))
        .then((userAccountIdentifier : UserAccountId | void) => {
            if (userAccountIdentifier) {
                dispatch(GetStartedFormActions.onSuccessfulUserSignUp(
                    userAccountIdentifier,
                    {
                        firstName : validationInputDataByFieldName.firstName.value,
                        lastName : validationInputDataByFieldName.lastName.value,
                        emailAddress: validationInputDataByFieldName.emailAddress.value,
                        phone : validationInputDataByFieldName.phone.value,
                        barName : validationInputDataByFieldName.barName.value,
                        country : validationInputDataByFieldName.country.value,
                        city : validationInputDataByFieldName.city.value,
                        state : validationInputDataByFieldName.state.value,
                        streetAddressLine1 : validationInputDataByFieldName.streetAddressLine1.value,
                        streetAddressLine2 : validationInputDataByFieldName.streetAddressLine2.value,
                        zipCode : validationInputDataByFieldName.zipCode.value,
                        optionalZipCode : validationInputDataByFieldName.optionalZipCode.value,
                        subscribeToBlog : validationInputDataByFieldName.subscribeToBlog.value,
                    }
                ))
                .then(() => {
                    window.location.href = PathUtils.getAbsolutePathForRequest('/user/welcome_to_bevspot/?public=true');
                });
            }
        });
    }
}

const mapStateToProps = (state : IGetStartedWithEmailProps) : IGetStartedWithEmailProps => {
    return {
        signUpAndLoginButtonsState : state.signUpAndLoginButtonsState,
        signUpOptionsState : state.signUpOptionsState,
    };
};

export const ConnectedGetStartedWithEmail = connect<IGetStartedWithEmailProps, object, object, IGetStartedWithEmailProps>(mapStateToProps)(GetStartedWithEmail);
